import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { formatDateWithHour } from 'src/utils/Date';
import * as Urls from 'src/constants/EndpointUrls';
import { Dl, Dd, Dt } from 'src/components/SecondaryPanel/SecondaryPanel';
import { Panel, Headding, Item } from 'src/components/PrimaryPanel/PrimaryPanel';
import { recordDisplay } from 'src/utils/Utils';
import { setAuditLogItem, getAuditLogItem } from 'src/reducers/clients/auditLogs';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { useTranslation } from 'react-i18next';

const change = value => {
  if (_.isString(value)) {
    return value;
  }
  if (_.isObject(value) && !_.isUndefined(value.filename)) {
    return value.filename || '-';
  }
  if (value === null) {
    return '-'
  }
  return JSON.stringify(value);
};

let AuditLogDetail = ({ auditLog }) => {
  const { t } = useTranslation()
  return (
    <div>
      <Panel>
        <Headding>{t('features.AuditLogs.AuditLogShow.update_information')}</Headding>
        <Item>
          <Dl>
            <Dt>{t('features.AuditLogs.AuditLogShow.account')}</Dt>
            <Dd>{recordDisplay(auditLog.actedUserEmail)}</Dd>
            <Dt>IP</Dt>
            <Dd>{recordDisplay(auditLog.ip)}</Dd>
            <Dt>{t('features.AuditLogs.AuditLogShow.operation_type')}</Dt>
            <Dd>{recordDisplay(auditLog.operationLabel)}</Dd>
            <Dt>{t('features.AuditLogs.AuditLogShow.operation_target')}</Dt>
            <Dd>{recordDisplay(auditLog.operationTargetName)}</Dd>
            <Dt>{t('features.AuditLogs.AuditLogShow.date')}</Dt>
            <Dd>{recordDisplay(formatDateWithHour(auditLog.createdAt))}</Dd>
          </Dl>
        </Item>
      </Panel>
      <h3 className="m-title-small">{t('features.AuditLogs.AuditLogShow.update_detail')}</h3>
      {auditLog.auditLogType === 'resource' ? (
        <div className="l-overflow-scroll">
          <table className="m-table-list m-table-fixed">
            <thead>
              <tr>
                <th style={{ width: '30%' }}>{t('features.AuditLogs.AuditLogShow.item')}</th>
                <th style={{ width: '35%' }}>{t('features.AuditLogs.AuditLogShow.before_change')}</th>
                <th style={{ width: '35%' }}>{t('features.AuditLogs.AuditLogShow.after_change')}</th>
              </tr>
            </thead>
            <tbody>
              {_.map(JSON.parse(auditLog.dataChanges), ([before, after], name) => (
                <tr key={name}>
                  <td className="u-break-all">{name}</td>
                  <td className="u-break-all">{change(before)}</td>
                  <td className="u-break-all">{change(after)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <h2>{auditLog.dataChanges}</h2>}
    </div>
  );
};

AuditLogDetail = connect(state => ({
  auditLog: getAuditLogItem(state)
}))(AuditLogDetail);

const AuditLogShow = ({ dispatch, auditLog }) => {
  const { t } = useTranslation();
  dispatch(setAuditLogItem(auditLog));
  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.AuditLogs.AuditLogShow.operation_history_detail')}</h1>
      </div>
      <div className="l-wrap-s l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('features.ClientUnitPrices.ClientUnitPricesList.setting')} path={Urls.CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.AuditLogs.AuditLogsList.Operation_history_list')} path={Urls.AUDIT_LOGS_LIST} />
            <BreadCrumb.Item label={t('features.AuditLogs.AuditLogShow.operation_history_detail')} />
          </BreadCrumb>
        </div>
        <AuditLogDetail />
      </div>
    </div>
  );
};

export default connect()(AuditLogShow);
